import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SigninComponent } from './authentication/signin/signin.component';
import { DashboardComponent } from 'src/app/dashboard/dashboard.component';
import { MainpanelComponent } from 'src/app/mainpanel/mainpanel.component';
import { QrcodeComponent } from 'src/app/qrcode/qrcode.component';
import { GenerateqrcodeComponent } from 'src/app/generateqrcode/generateqrcode.component';
import { TopbarComponent } from './topbar/topbar.component';
import { AdminUserComponent } from './admin-user/admin-user.component';
import { ODuserComponent } from './oduser/oduser.component';
import { SettingComponent } from './setting/setting.component';
import { ODuserTableComponent } from './oduser-table/oduser-table.component';
import { ViewMapComponent } from './view-map/view-map.component';
import { TableFilterComponent } from './table-filter/table-filter.component';
import { MapFilterComponent } from './map-filter/map-filter.component';
import { AuthenticationComponent } from './authentication/authentication.component';
import { AuthGuardService } from '../auth-guard.service';
import { AppComponent } from './app.component';
import { LivedbComponent } from './livedb/livedb.component';
import { AdminmapComponent } from './adminmap/adminmap.component';


export const Approute: Routes = [
    { path: '', redirectTo: '/authentication', pathMatch: 'full' },
    {
        path: 'dashboard',
        component: DashboardComponent, canActivate: [AuthGuardService],
        children: [
            {
              path: 'mainpanel_SubAdmin',
              component: MainpanelComponent,
              data: { Key: "mainpanel" },

            },
            {
                path: 'Admin_User',
                component: AdminUserComponent,
                data: { Key: "Admin_User" },

            },
            {
                path: 'OD_User',
                component: ODuserComponent,
                data: { Key: "OD_User" },

            },
            {
                path: 'Setting',
                component: SettingComponent,
                data: { Key: "Setting" },

            },
            {
                path: 'ODuser_Table',
                component: ODuserTableComponent,
                data: { Key: "ODuser_Table" },

            },
            {
                path: 'On_DutyUser',
                component: ViewMapComponent,
                data: { Key: "On_DutyUser" },

            },
            {
                path: 'ODuser_Filter',
                component: TableFilterComponent,
                data: { Key: "ODuser_Filter" },

            },
            {
                path: 'Filter_map',
                component: MapFilterComponent,
                data: { Key: "Filter_map" },

            },
            {
                path: 'LiveDashBoard',
                component: LivedbComponent,
                data: { Key: "Livedashboard" },

            }, //AdminmapComponent
            {
                path: 'LiveDashBoard_admin',
                component: AdminmapComponent,
                data: { Key: "LiveDashBoard _admin" },

            },
        ]
    },

    {
        path: 'qrcode',
        component: QrcodeComponent
    },
    {
        path: 'generateqrcode',
        component:GenerateqrcodeComponent
    },
    {
        path: 'authentication', component: AuthenticationComponent,
        children: [
          { path: '', component: SigninComponent, data: { title: 'signin' } },

        ]
      }
];



@NgModule({
    imports: [RouterModule.forRoot(Approute, { useHash: true })],
    exports: [RouterModule],

})

export class AppRouting { }
